import React, { useMemo, useState } from 'react';
import DHeader from '../../pieces/DHeader';
import DText from '../../pieces/DText';
import DCode from '../../pieces/DCode';

export default function WorkflowAppState() {

    return (
        <div>
            <DHeader>App/Graph State</DHeader>
       
            <DText>
            The App State is a hidden piece of the workflow and comes built-in to the Flow. It is where the state of each Node(the Node's outputs) is stored.
            </DText>

            <DText>
            While App State is handled implicitly, you can access it using Flow.graph_state.
            </DText>

          
            
            {/* <DCode>
                {`python QuickStart.py`}
            </DCode> */}
       
        </div>
    )
}